export const PRINT_SETUP = 'setup';
export const PRINT_READY = 'ready';
export const PRINT_NONE = 'none';

export const resizeForPrint = (columnDefs) => {
  const gridWidth = 1110; //Adjust the width to accommodate column widths
  const nonPinnedColsWidth = gridWidth - 230;
  const nonHiddenCols = columnDefs.filter((col) => !col.hide);
  const colWidth = nonPinnedColsWidth / nonHiddenCols.length;

  return columnDefs.map((def) => ({
    ...def,
    minWidth: colWidth,
    maxWidth: colWidth
  }));
};

export const resizeAutoGroupColumnDef = (columnDef) => {
  //Shrink the Account column in order to fit columns with large data numbers
  return {
    ...columnDef,
    minWidth: 200,
    maxWidth: 200
  };
};
